import { render } from "./NewWiki.vue?vue&type=template&id=5bcaf2f2&scoped=true"
import script from "./NewWiki.vue?vue&type=script&lang=js"
export * from "./NewWiki.vue?vue&type=script&lang=js"

import "./NewWiki.vue?vue&type=style&index=0&id=5bcaf2f2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcaf2f2"]])

export default __exports__
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QStepper,QStep,QSeparator,QStepperNavigation,QBtn,QInnerLoading,QImg});
